import { render, staticRenderFns } from "./UploadNewVersion.vue?vue&type=template&id=64394ae3"
import script from "./UploadNewVersion.vue?vue&type=script&lang=js"
export * from "./UploadNewVersion.vue?vue&type=script&lang=js"
import style0 from "./UploadNewVersion.vue?vue&type=style&index=0&id=64394ae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports